const e = {
  loader: "senecaLoader"
}, n = {
  loader: "goStudentLoader"
};
export {
  e as defaultIconAssignments,
  n as goStudentLearning
};
